exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".iconsContainer__InvoicesCompanyTable-module___1FsU1 {\n    flex-direction: column;\n}\n\n.iconsContainer__InvoicesCompanyTable-module___1FsU1 > div:nth-child(3) {\n    margin: 0;\n    padding: 0 2px;\n}", ""]);

// Exports
exports.locals = {
	"iconsContainer": "iconsContainer__InvoicesCompanyTable-module___1FsU1"
};